export default {
  index: [
    {
      path: '/dkrequest',
      component: resolve => require(['./dkrequestIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dk_request/_router.js